import { Link, useLocation, useNavigate } from "react-router-dom";
import { Package, ShoppingBag, Mail, LogOut, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthApi } from "@/api/api";
import { toast } from "sonner";

const navLinks = [
    { title: "Sản phẩm", path: "/admin/product", icon: <Package size={18} /> },
    { title: "Đơn hàng", path: "/admin/order", icon: <ShoppingBag size={18} /> },
    { title: "Liên hệ", path: "/admin/email", icon: <Mail size={18} /> },
];

const AdminNavbar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await AuthApi.logout();
            toast.success("Đăng xuất thành công!");
        } catch (error) {
            console.error("Lỗi khi đăng xuất:", error);
        } finally {
            navigate("/admin/login", { replace: true });
        }
    };

    return (
        <header className="sticky top-0 z-50 w-full border-b border-border bg-card shadow-sm">
            <div className="container mx-auto px-4 h-16 flex items-center justify-between">

                {/* LOGO & BRAND */}
                <div className="flex items-center gap-2 text-primary">
                    <LayoutDashboard size={24} />
                    <span className="font-heading text-xl font-bold uppercase tracking-wider hidden sm:inline-block">
            Memys Admin
          </span>
                </div>

                {/* NAVIGATION LINKS */}
                <nav className="flex items-center gap-1 md:gap-2">
                    {navLinks.map((link) => {
                        const isActive = location.pathname.startsWith(link.path);
                        return (
                            <Link key={link.path} to={link.path}>
                                <Button
                                    variant={isActive ? "secondary" : "ghost"}
                                    className={`gap-2 ${isActive ? "bg-primary/10 text-primary font-semibold" : "text-muted-foreground hover:text-foreground"}`}
                                >
                                    {link.icon}
                                    <span className="hidden md:inline-block">{link.title}</span>
                                </Button>
                            </Link>
                        );
                    })}
                </nav>

                {/* LOGOUT BUTTON */}
                <div className="flex items-center border-l border-border pl-4 ml-2">
                    <Button
                        variant="ghost"
                        onClick={handleLogout}
                        className="gap-2 text-destructive hover:bg-destructive/10 hover:text-destructive px-2 md:px-4"
                    >
                        <LogOut size={18} />
                        <span className="hidden md:inline-block">Đăng xuất</span>
                    </Button>
                </div>

            </div>
        </header>
    );
};

export default AdminNavbar;